import { useRef, useState } from 'react';
import { MongoFieldsAPI } from '../utils/MongoFieldsAPI';
import { MongoDataAPI } from '../utils/MongoDataAPI';
import { MongoStatsAPI } from '../utils/MongoStatsAPI';
import { useDispatch } from 'react-redux';
import * as snackbarActions from '../redux/actions/snackbarActions';

const useMongoAPI = (mongoSchemaName, {} = {}) => {
  const srcDataAPI = useRef(new MongoDataAPI(mongoSchemaName));
  const srcFieldsAPI = useRef(new MongoFieldsAPI(mongoSchemaName));
  const srcStatsAPI = useRef(new MongoStatsAPI(mongoSchemaName));

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();

  const dispatch = useDispatch();
  const alertErr = (value) => dispatch(snackbarActions.setErrMsg(value));

  const proxyGetter = {
    get(target, prop, receiver) {
      const originalMethod = target[prop];
      if (typeof originalMethod === 'function') {
        return async (...args) => {
          const data = await safeCall(originalMethod, args, target);
          return data;
        };
      }
      return originalMethod;
    },
  };

  const dataAPI = useRef(new Proxy(srcDataAPI.current, proxyGetter));
  const fieldsAPI = useRef(new Proxy(srcFieldsAPI.current, proxyGetter));
  const statsAPI = useRef(new Proxy(srcStatsAPI.current, proxyGetter));

  const safeCall = async (func, args, thisContext = null) => {
    try {
      setIsLoading(true);
      const data = await func.apply(thisContext, args);
      return data;
    } catch (err) {
      alertErr(
        'Request failed! Try refreshing. If the issue persists, contact the site administrator.'
      );
      console.error(err);
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    dataAPI: dataAPI.current,
    fieldsAPI: fieldsAPI.current,
    statsAPI: statsAPI.current,
    isLoading,
    error,
    srcDataAPI: srcDataAPI.current,
    srcFieldsAPI: srcFieldsAPI.current,
    srcStatsAPI: srcStatsAPI.current,
  };
};

export default useMongoAPI;
